module.exports = __webpack_public_path__ + "static/img/FR516.95296fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/FR516.png
// module id = 69
// module chunks = 1